import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ModalVideo from 'react-modal-video';
import SectionTitle from '../../components/SectionTitle';
import Button from '../../components/Button';

import shapeImg from '../../assets/img/about/shape-2-1.png';
import aboutImg1 from '../../assets/img/about/about-2-1.jpg';
import aboutImg2 from '../../assets/img/about/about-2-2.jpg';
import aboutImg3 from '../../assets/img/about/about-2-3.jpg';

const About = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div id="it-about" className="it-about-2-area  p-relative pt-120 pb-120">
      <ModalVideo
        channel="youtube"
        isOpen={isOpen}
        videoId="PO_fBTkoznc"
        onClose={() => openModal()}
      />
      <div className="it-about-3-shape-1 d-none d-xl-block">
        <img src={shapeImg} alt="" />
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div
            className="col-xl-6 col-lg-6 order-1 order-lg-0 wow animate__fadeInLeft"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <div className="it-about-2-left d-flex align-items-center justify-content-center justify-content-lg-between">
              <div className="it-about-2-thumb-wrap">
                <div className="it-about-2-thumb style-1">
                  <img src={aboutImg1} alt="" />
                </div>
                <div className="it-about-2-thumb p-relative style-2">
                  <img src={aboutImg2} alt="" />
                  <div className="it-about-2-video">
                    <Link
                      className="play-icon pulse popup-video"
                      to="#"
                      onClick={() => openModal()}
                    >
                      <i className="fa-sharp fa-solid fa-play"></i>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="it-about-2-thumb style-3">
                <img src={aboutImg3} alt="" />
              </div>
            </div>
          </div>
          <div
            className="col-xl-6 col-lg-6 order-0 order-lg-1 wow animate__fadeInRight"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <div className="it-about-2-right">
              <div className="it-about-2-content">
                <SectionTitle
                  itemClass="it-about-2-title-box mb-20"
                  subTitleClass="it-section-subtitle"
                  subTitle="About us"
                  titleClass="it-section-title"
                  title="We have been working in the dental treatment profession for
                    about 25 years long."
                />

                <span>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt labore.
                </span>
                <p className="mb-25">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation sed do
                  eiusmod tempor.Lorem ipsum dolor sit amet, consectetur
                  adipiscing elit.
                </p>
                <div className="it-about-2-tel-wrap flex-wrap d-sm-flex align-items-center">
                  <Link className="it-btn-theme mr-55" to="/about-us">
                    <Button btnText="More About Us" />
                  </Link>
                  <div className="it-about-2-tel-box d-flex align-items-center">
                    <div className="it-about-2-tel-icon">
                      <span>
                        <i className="flaticon-message"></i>
                      </span>
                    </div>
                    <div className="it-about-2-tel-text">
                      <span>Emergency</span>
                      <a className="hover-anim" href="tel:99012356987">
                        (+99) 012356987
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
